import config from "../config/config.json";

export function getModuleAccess(module) {
    if (window.localStorage.getItem("isAdmin") === "true") {
        let visibility = config.cards.find(e => e.routing === module)
        return visibility?.visibilityAdmin === true;
    } else {
        let moduleAccess = config.cards.find(e => e.routing === module)?.permissionName;
        if (!moduleAccess) {
            return true;
        }
        let permissionsItems = JSON.parse(window.localStorage.getItem("userData"))?.realmAccess || [];
        let activeCount = window.localStorage.getItem("uuidSetCookie");
        let activePermission = permissionsItems.find(item => item.uuid === activeCount);
        return activePermission?.grants.includes(moduleAccess) || false;
    }
}

export function getActivePermissionAccess(resultsUserPermissions, moduleName) {
    const permissionsItems = resultsUserPermissions?.permissionsByAccount || [];
    const activeCount = window.localStorage.getItem("uuidSetCookie");

    if (window.localStorage.getItem("isAdmin") === "true") {
        const visibility = config.cards.find(e => e.permissionName === moduleName);
        if (visibility?.visibilityAdmin === true) {
            return true;
        }
        if (moduleName.includes("/")) {
            const [permissionFather] = moduleName.split("/");
            const fatherVisibility = config.cards.find(e => e.permissionName === permissionFather);
            return fatherVisibility?.visibilityAdmin === true ?? false;
        }
    }

    const activePermission = permissionsItems.find(
        (item) => item.accountUuid === activeCount
    );

    if (moduleName.includes("/")) {
        const [permissionFather, permissionAction] = moduleName.split("/");
        const modulePermissions = activePermission?.permissions?.modules?.[permissionFather];
        return modulePermissions?.includes(permissionAction) ?? false;
    }

    const hasModuleAccess =
        activePermission?.permissions?.modules?.hasOwnProperty(moduleName) || false;

    return hasModuleAccess;
}
